import type { ControlRow } from '../../types';

/** Static desktop / mobile control bindings (display only). */
export const CONTROLS_ROWS: readonly ControlRow[] = [
  { action: 'Move', binding: 'W A S D · Arrow keys' },
  { action: 'Fire', binding: 'Space · F · Tap (mobile)' },
  { action: 'Hold fire (railgun)', binding: 'Hold Space' },
  {
    action: 'Chaff (deflect enemy bolts / missiles)',
    binding: 'Select CHAFF · Space / F (single-shot)',
  },
  { action: 'Missile lock', binding: 'Hold X · Long-press (mobile)' },
  { action: 'Incoming enemy missile lock', binding: 'Red corner LOCK warning (3s) then launch' },
  { action: 'Cycle weapon', binding: 'V · Click playfield · HUD boxes' },
  { action: 'Select missiles', binding: 'Missile HUD box' },
  { action: 'Select railgun', binding: 'Railgun HUD box' },
  { action: 'Select chaff', binding: 'Chaff HUD box' },
  { action: 'Pause', binding: '⏸ icon (top-right)' },
  { action: 'Open settings', binding: '⚙ gear (top-right)' },
  { action: 'Resume from pause', binding: 'Space · ▶ icon (top-right)' },
  { action: 'Mobile move', binding: 'Device tilt' },
];
